/* Approved technical mesh drawing. This view does not calculate quantities,
   prices, recommendations or cart items; its input is the existing mesh name. */
(function (host, factory) {
  'use strict';
  var api = factory(host);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (host && host.document) host.OutbackMeshPreview = api;
})(typeof window === 'undefined' ? null : window, function (host) {
  'use strict';

  /* Keep the supplied gaps unchanged. Their sum and the separate nominal height
     can differ. Knot shapes are illustrations, not wire-gauge specifications. */
  var profiles = [
    { key: '6-70-30', code: '6/70/30', wires: 6, height: 70, stay: 300, gaps: [115,127,140,152,178], source: 'chart' },
    { key: '6-90-30', code: '6/90/30', wires: 6, height: 90, stay: 300, gaps: [140,152,178,203,229], source: 'chart' },
    { key: '7-90-30', code: '7/90/30', wires: 7, height: 90, stay: 300, gaps: [115,127,140,152,178,203], source: 'chart' },
    { key: '8-80-15', code: '8/80/15', wires: 8, height: 80, stay: 150, gaps: [75,89,102,115,127,152,178], source: 'chart', note: 'Chart gaps total 838 mm · nominal height 80 cm' },
    { key: '8-90-15', code: '8/90/15', wires: 8, height: 90, stay: 150, gaps: [89,102,115,127,140,152,170], source: 'chart' },
    { key: '8-90-30', code: '8/90/30', wires: 8, height: 90, stay: 300, gaps: [89,102,115,127,140,152,170], source: 'chart' },
    { key: '8-115-15', code: '8/115/15', wires: 8, height: 115, stay: 150, gaps: [115,127,140,152,178,203,229], source: 'chart' },
    { key: '8-115-30', code: '8/115/30', wires: 8, height: 115, stay: 300, gaps: [115,127,140,152,178,203,229], source: 'chart' },
    { key: '11-142-15', code: '11/142/15', wires: 11, height: 142, stay: 150, gaps: [75,89,102,115,127,140,152,178,203,229], source: 'chart' },
    { key: '11-142-30', code: '11/142/30', wires: 11, height: 142, stay: 300, gaps: [75,89,102,115,127,140,152,178,203,229], source: 'ops' },
    { key: '5-51-30', code: '5/51/30', wires: 5, height: 51, stay: 300, gaps: [115,127,140,128], source: 'ops', apron: true },
    { key: '16-180-15', code: '16/180/15', wires: 16, height: 180, stay: 150, gaps: [75,75,75,75,75,100,100,125,125,150,150,150,180,180,180], source: 'fixed-chart', fixed: true, note: 'Diagram gaps total 1,815 mm · labelled height 1,800 mm' }
  ];
  var byKey = {};
  /* Family-qualified identity (Codex update 70d943b; Josh 12 Oct 2026): a fixed-knot name never resolves to a
     hinge-joint profile with the same code, or the reverse. A name without a family keeps the original lookup. */
  profiles.forEach(function (profile) { profile.family = profile.fixed ? 'fixed' : 'hinge'; byKey[profile.family + ':' + profile.key] = profile; });
  var defaultCopy = {
    hinge: 'Hinge joint', fixed: 'Fixed knot', apron: 'Apron / dog skirt — add-on',
    nominalHeight: 'nominal height', nominalWidth: 'nominal mesh width',
    wireCount: 'horizontal wires', staySpacing: 'between stays',
    approximate: 'Illustration · dimensions approximate',
    frontProfile: 'Front profile', apronProfile: 'Apron mesh · laid out',
    sourceChart: 'Spacing: Outback chart', sourceOps: 'Spacing: Outback Ops',
    sourceFixed: 'Spacing: supplied fixed-knot diagram',
    chartTotal: 'Chart gaps total {total} mm · nominal height {height} cm',
    fixedTotal: 'Diagram gaps total {total} mm · labelled height {height} mm',
    heightDimension: '{height} cm nominal', widthDimension: '{height} cm nominal width',
    meshProfile: 'mesh profile',
    description: '{count} horizontal wires; nominal {dimension} {height} centimetres; vertical stays {spacing} millimetres apart. Approximate horizontal wire gaps from bottom to top: {gaps} millimetres.',
    heightWord: 'height', widthWord: 'mesh width',
    hingeDescription: 'Six-turn hinge wraps are illustrative.',
    fixedDescription: 'Interior fixed knots, top and bottom hinge wraps, and line-wire crimps are illustrative.',
    equalScale: 'Horizontal and vertical dimensions use equal scale.',
    apronDescription: 'Apron mesh shown laid out, not as a standalone upright fence.',
    fixedGapDescription: 'The supplied gap labels sum to 1,815 millimetres, while the diagram labels the height 1,800 millimetres.'
  };
  var instances = new WeakMap();
  var active = [];
  var nextId = 0;

  function escape(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }
  function familyOf(name) {
    return typeof name !== 'string' ? '' : /fixed|knot|\bfk\b/i.test(name) ? 'fixed' : /hinge|\bhj\b/i.test(name) ? 'hinge' : '';
  }
  function findProfile(name) {
    if (typeof name !== 'string') return null;
    var match = /(?:^|[^0-9])(\d{1,2})\s*[\/-]\s*(\d{2,3})\s*[\/-]\s*(\d{1,2})(?!\d)/.exec(name);
    if (!match) return null;
    var key = match[1] + '-' + match[2] + '-' + match[3], family = familyOf(name);
    return (family ? byKey[family + ':' + key] : byKey['hinge:' + key] || byKey['fixed:' + key]) || null;
  }
  function qualifiedName(profile) { return (profile.family === 'fixed' ? 'Fixed knot ' : 'Hinge joint ') + profile.code; }
  function getProfile(name) {
    var profile = findProfile(name);
    if (!profile) return null;
    var copy = {};
    Object.keys(profile).forEach(function (key) { copy[key] = key === 'gaps' ? profile.gaps.slice() : profile[key]; });
    return copy;
  }
  function copyFrom(input) {
    var copy = {};
    Object.keys(defaultCopy).forEach(function (key) {
      copy[key] = input && typeof input[key] === 'string' ? input[key] : defaultCopy[key];
    });
    return copy;
  }
  function wrapperCopy(wrapper) {
    var raw = wrapper.getAttribute('data-mesh-copy');
    try { return copyFrom(raw ? JSON.parse(raw) : null); } catch (error) { return copyFrom(null); }
  }
  function format(text, values) {
    return String(text).replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
    });
  }
  function measuredLabel(text, placeholder, amount, prefix) {
    return text.indexOf('{' + placeholder + '}') !== -1 ? format(text, (function () {
      var values = {}; values[placeholder] = amount; return values;
    })()) : prefix + ' ' + text;
  }
  function palette(dark) {
    return dark ? { text:'#e4ede1', muted:'#a4b9a3', dim:'#94ac92', gold:'#e0bd62', shadow:'#06110b', wireDark:'#697674', wireMid:'#acb6b2', wireLight:'#f5f8ec' } :
      { text:'#334734', muted:'#707f70', dim:'#9aa895', gold:'#a07826', shadow:'#68736b', wireDark:'#637072', wireMid:'#a8b1b0', wireLight:'#f7fbf5' };
  }
  function safeId(value) { return 'ob-mesh-' + String(value || 'profile').replace(/[^a-zA-Z0-9_-]/g, '-').slice(0, 100); }
  function defs(id, c) {
    function gradient(name, x1, y1, x2, y2) {
      return '<linearGradient id="' + id + '-' + name + '" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"><stop offset="0" stop-color="' + c.wireDark + '"/><stop offset=".22" stop-color="#b7c3bc"/><stop offset=".40" stop-color="' + (name === 'coil' ? '#dce5db' : c.wireLight) + '"/><stop offset=".55" stop-color="' + c.wireMid + '"/><stop offset=".84" stop-color="#808e8d"/><stop offset="1" stop-color="#515e61"/></linearGradient>';
    }
    var svg = '<defs>' + gradient('horizontal',0,0,0,1) + gradient('vertical',0,0,1,0) + gradient('coil',0,0,.9,1);
    var coilCentres = [-9.4,-7.7,-6,-4.3,-2.6,-.9];
    svg += '<g id="' + id + '-coil-backs">';
    coilCentres.slice(0,-1).forEach(function (cx) {
      svg += '<path d="M ' + (cx+.425) + ',1.85 C ' + (cx+.8) + ',1.85 ' + (cx+.9) + ',-1.85 ' + (cx+1.275) + ',-1.85" fill="none" stroke="#71817c" stroke-width="1.44" stroke-linecap="round"/>';
    });
    var entrance = 'M 0,-1.1 C -1.8,-2 -5.8,-2.6 -9.825,-1.85';
    svg += '</g><g id="' + id + '-knot-back"><use href="#' + id + '-coil-backs"/><path d="' + entrance + '" fill="none" stroke="' + c.wireDark + '" stroke-width="1.75" stroke-linecap="round"/><path d="' + entrance + '" fill="none" stroke="url(#' + id + '-coil)" stroke-width="1.24" stroke-linecap="round"/></g><g id="' + id + '-knot-top-back"><use href="#' + id + '-coil-backs"/></g>';
    svg += '<g id="' + id + '-knot-coils">';
    coilCentres.forEach(function (cx) {
      var path = 'M ' + (cx-.425) + ',-1.85 C ' + (cx-.05) + ',-1.85 ' + (cx+.05) + ',1.85 ' + (cx+.425) + ',1.85';
      svg += '<path d="' + path + '" fill="none" stroke="#53645f" stroke-width="1.63" stroke-linecap="round"/>';
      svg += '<path d="' + path + '" fill="none" stroke="url(#' + id + '-coil)" stroke-width="1.39" stroke-linecap="round"/>';
      svg += '<path d="M ' + (cx-.45) + ',-1.6 Q ' + (cx-.28) + ',-1.1 ' + (cx-.14) + ',-.35" fill="none" stroke="#eef3e9" stroke-opacity=".4" stroke-width=".18" stroke-linecap="round"/>';
    });
    var exit = 'M -.475,1.85 Q .1,2.5 0,3.3 L 0,4.8';
    svg += '</g><g id="' + id + '-knot-front"><use href="#' + id + '-knot-coils"/><path d="' + exit + '" fill="none" stroke="' + c.wireDark + '" stroke-width="1.75" stroke-linecap="round"/><path d="' + exit + '" fill="none" stroke="url(#' + id + '-vertical)" stroke-width="1.18" stroke-linecap="round"/></g><g id="' + id + '-knot-bottom-front"><use href="#' + id + '-knot-coils"/></g>';
    svg += '<g id="' + id + '-fixed-knot">';
    var tie = 'M -.3,4.2 C -2.6,2.7 -4.8,1.8 -5.3,-.5 Q -5.8,-2.8 -4.7,-1.8 C -3.3,-3.8 -2.2,-6.1 0,-6.1 C 2.2,-6.1 3.3,-3.8 4.7,-1.8 Q 5.8,-2.8 5.3,-.5 C 4.8,1.8 2.6,2.7 .3,4.2';
    svg += '<path d="' + tie + '" fill="none" stroke="' + c.wireDark + '" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/><path d="' + tie + '" fill="none" stroke="url(#' + id + '-coil)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>';
    [4.3,5.9,7.5,9.1].forEach(function (yy) {
      var wrap = 'M -1.2,' + yy + ' C -2.0,' + (yy+.35) + ' -1.1,' + (yy+1.1) + ' .4,' + (yy+1.45) + ' Q 1.9,' + (yy+1.8) + ' 1.45,' + (yy+2.2);
      svg += '<path d="' + wrap + '" fill="none" stroke="' + c.wireDark + '" stroke-width="1.8" stroke-linecap="round"/><path d="' + wrap + '" fill="none" stroke="url(#' + id + '-coil)" stroke-width="1.15" stroke-linecap="round"/>';
    });
    return svg + '</g></defs>';
  }
  function xmlText(x, y, label, color, size, extra) {
    return '<text x="' + x + '" y="' + y + '" fill="' + color + '" font-family="Barlow,Arial,sans-serif" font-size="' + (size || 12) + '" ' + (extra || '') + '>' + escape(label) + '</text>';
  }
  function line(x1, y1, x2, y2, color, width, extra) {
    return '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="' + color + '" stroke-width="' + (width || 1) + '" ' + (extra || '') + '/>';
  }
  function tube(x, y, width, height, id, vertical) {
    var radius = Math.min(width,height)/2;
    return '<rect x="' + (x+.55) + '" y="' + (y+.7) + '" width="' + width + '" height="' + height + '" rx="' + radius + '" fill="#17251c" opacity=".14"/>' +
      '<rect x="' + x + '" y="' + y + '" width="' + width + '" height="' + height + '" rx="' + radius + '" fill="url(#' + id + '-' + (vertical ? 'vertical' : 'horizontal') + ')"/>';
  }
  function crimpedWire(x, yy, mmWide, stay, thick, c) {
    var path = 'M ' + (x(0)-10) + ',' + yy;
    for (var start=0, bay=0; start<mmWide; start+=stay, bay++) {
      var a = 1.55 * (bay%2 === 0 ? 1 : -1);
      path += ' L ' + x(start+stay*.32) + ',' + yy + ' Q ' + x(start+stay*.37) + ',' + yy + ' ' + x(start+stay*.40) + ',' + (yy+a*.25) + ' L ' + x(start+stay*.48) + ',' + (yy+a*.85) + ' Q ' + x(start+stay*.50) + ',' + (yy+a) + ' ' + x(start+stay*.52) + ',' + (yy+a*.85) + ' L ' + x(start+stay*.60) + ',' + (yy+a*.25) + ' Q ' + x(start+stay*.63) + ',' + yy + ' ' + x(start+stay*.68) + ',' + yy + ' L ' + x(start+stay) + ',' + yy;
    }
    path += ' L ' + (x(mmWide)+2) + ',' + yy;
    return '<g data-line-wire="fixed"><path d="' + path + '" transform="translate(.45 .55)" fill="none" stroke="' + c.shadow + '" opacity=".14" stroke-width="' + thick + '" stroke-linejoin="round"/><path d="' + path + '" fill="none" stroke="' + c.wireDark + '" stroke-width="' + thick + '" stroke-linejoin="round" stroke-linecap="round"/><path d="' + path + '" fill="none" stroke="' + c.wireMid + '" stroke-width="' + (thick*.68) + '" stroke-linejoin="round" stroke-linecap="round"/><path d="' + path + '" transform="translate(0 -.28)" fill="none" stroke="' + c.wireLight + '" stroke-opacity=".8" stroke-width="' + (thick*.22) + '" stroke-linejoin="round" stroke-linecap="round"/></g>';
  }
  function buildSvg(meshName, width, options) {
    var mesh = findProfile(meshName);
    if (!mesh || !mesh.gaps.length) return '';
    options = options || {};
    var numericWidth = Number(width);
    var w = Math.max(240,Math.round(isFinite(numericWidth) && numericWidth > 0 ? numericWidth : 370));
    var c = palette(!!options.dark), id = safeId(options.id), copy = copyFrom(options.copy);
    var gaps = mesh.gaps, levels = [0];
    gaps.forEach(function (gap) { levels.push(levels[levels.length-1]+gap); });
    var total = levels[levels.length-1];
    var baseMmWide = w>=540 ? 1200 : w>=410 ? 900 : 600;
    var leftMargin=46, rightMargin=52;
    var scale = Math.min(.38,(w-leftMargin-rightMargin)/baseMmWide,440/total);
    var mmWide = mesh.fixed ? Math.max(mesh.stay,Math.floor((w-leftMargin-rightMargin)/scale/mesh.stay)*mesh.stay) : baseMmWide;
    var wireWidth = mmWide*scale;
    var left = leftMargin+(w-leftMargin-rightMargin-wireWidth)/2, right = left+wireWidth;
    var top=62, bottom=top+total*scale, h=Math.ceil(bottom+50);
    var x = function (mm) { return left+mm*scale; };
    var y = function (mm) { return bottom-mm*scale; };
    var stay = mesh.stay;
    var kind = mesh.fixed ? copy.fixed : mesh.apron ? copy.apron : copy.hinge;
    var description = format(copy.description,{ count:mesh.wires, dimension:mesh.apron ? copy.widthWord : copy.heightWord, height:mesh.height, spacing:stay, gaps:gaps.join(', ') });
    description += ' ' + (mesh.fixed ? copy.fixedDescription : copy.hingeDescription) + ' ' + copy.equalScale;
    if (mesh.apron) description += ' ' + copy.apronDescription;
    if (mesh.fixed) description += ' ' + copy.fixedGapDescription;
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + w + ' ' + h + '" role="img" aria-labelledby="' + id + '-title ' + id + '-desc"><title id="' + id + '-title">' + escape(kind+' '+mesh.code+' '+copy.meshProfile) + '</title><desc id="' + id + '-desc">' + escape(description) + '</desc>' + defs(id,c);
    var stayPositions = [];
    for (var position=0; position<=mmWide; position+=stay) stayPositions.push(position);
    stayPositions.forEach(function (mm) { svg += tube(x(mm)-.85,top,1.7,bottom-top,id,true); });
    var edgeRow = function (i) { return i===0 ? 'bottom' : i===levels.length-1 ? 'top' : 'interior'; };
    var hingeRow = function (i) { return !mesh.fixed || edgeRow(i)!=='interior'; };
    stayPositions.forEach(function (mm) {
      levels.forEach(function (level,i) {
        if (hingeRow(i)) svg += '<use href="#' + id + '-' + (edgeRow(i)==='top' ? 'knot-top-back' : 'knot-back') + '" transform="translate(' + x(mm) + ' ' + y(level) + ') scale(.78)"/>';
      });
    });
    levels.forEach(function (mm,i) {
      var edge = i===0 || i===levels.length-1;
      var thick = mesh.fixed ? (edge ? 2.2 : 1.96) : (edge ? 2.4 : 1.9);
      svg += mesh.fixed ? crimpedWire(x,y(mm),mmWide,stay,thick,c) : tube(left-10,y(mm)-thick/2,wireWidth+12,thick,id);
    });
    stayPositions.forEach(function (mm) {
      levels.forEach(function (level,i) {
        var row = edgeRow(i), hinge = hingeRow(i);
        var symbol = hinge ? (row==='bottom' ? 'knot-bottom-front' : 'knot-front') : 'fixed-knot';
        svg += '<use href="#' + id + '-' + symbol + '" data-knot-kind="' + (hinge ? 'hinge' : 'fixed') + '" data-knot-row="' + row + '" transform="translate(' + x(mm) + ' ' + y(level) + ') scale(.78)"/>';
      });
    });
    var heightX = left-24;
    svg += line(heightX,top,heightX,bottom,c.dim,.9);
    [top,bottom].forEach(function (yy) { svg += line(heightX-4,yy,heightX+4,yy,c.dim,.9) + line(heightX+6,yy,left-10,yy,c.dim,.65); });
    var dimension = format(mesh.apron ? copy.widthDimension : copy.heightDimension,{ height:mesh.height });
    svg += xmlText(heightX-11,(top+bottom)/2,dimension,c.text,11,'text-anchor="middle" transform="rotate(-90 ' + (heightX-11) + ' ' + ((top+bottom)/2) + ')"');
    var dimY = top-29;
    svg += line(x(0),dimY,x(stay),dimY,c.gold,.9);
    [0,stay].forEach(function (mm) { svg += line(x(mm),dimY-5,x(mm),top-10,c.dim,.6) + line(x(mm)-3,dimY+3,x(mm)+3,dimY-3,c.gold,1); });
    svg += xmlText((x(0)+x(stay))/2,dimY-11,stay+' mm',c.gold,13,'text-anchor="middle" font-weight="500"');
    var gapX = right+13;
    svg += line(gapX,top,gapX,bottom,c.dim,.7);
    levels.forEach(function (mm) { svg += line(gapX-3,y(mm),gapX+3,y(mm),c.dim,.9); });
    gaps.forEach(function (gap,i) { svg += xmlText(gapX+7,(y(levels[i])+y(levels[i+1]))/2+4,gap,c.text,12,'font-variant-numeric="tabular-nums" data-gap="' + gap + '"'); });
    svg += xmlText((left+right)/2,bottom+31,mesh.code,c.text,18,'text-anchor="middle" font-weight="500"');
    return svg + '</svg>';
  }
  function setText(wrapper, selector, text) {
    var node = wrapper.querySelector(selector);
    if (node) node.textContent = text;
  }
  function isDark(wrapper) {
    var preference = wrapper.getAttribute('data-mesh-theme');
    return preference === 'dark' || (preference === 'auto' && host && host.matchMedia && host.matchMedia('(prefers-color-scheme: dark)').matches);
  }
  function draw(record, width) {
    if (record.diagram.isConnected === false) { destroy(record.wrapper); return; }
    var measured = width || record.diagram.getBoundingClientRect().width;
    /* Closed details have no width. The first opening triggers ResizeObserver. */
    var chosenWidth = Math.round(measured || record.width || 370);
    var dark = isDark(record.wrapper);
    var meshName = qualifiedName(record.mesh);
    if (record.drawnMesh === meshName && record.width === chosenWidth && record.dark === dark && record.drawnCopy === record.copyKey) return;
    record.diagram.innerHTML = buildSvg(meshName,chosenWidth,{ id:record.id, dark:dark, copy:record.copy });
    record.width=chosenWidth; record.dark=dark; record.drawnMesh=meshName; record.drawnCopy=record.copyKey;
  }
  function destroy(wrapper) {
    var record = instances.get(wrapper);
    if (!record) return;
    if (record.observer) record.observer.disconnect();
    if (record.resizeHandler && host) host.removeEventListener('resize',record.resizeHandler);
    if (record.toggleHandler) wrapper.removeEventListener('toggle',record.toggleHandler);
    instances.delete(wrapper);
    var index = active.indexOf(record);
    if (index !== -1) active.splice(index,1);
  }
  function render(wrapper, meshName) {
    if (!wrapper || typeof wrapper.querySelector !== 'function') return false;
    var mesh = findProfile(meshName), diagram = wrapper.querySelector('[data-mesh-diagram]');
    if (!mesh || !diagram) {
      destroy(wrapper);
      if (diagram) diagram.innerHTML = '';
      ['code','type','note','source','specs','profile'].forEach(function (name) { setText(wrapper,'[data-mesh-'+name+']',''); });
      wrapper.hidden = true;
      return false;
    }
    wrapper.hidden = false;
    var record = instances.get(wrapper);
    if (record && record.diagram !== diagram) { destroy(wrapper); record=null; }
    if (!record) {
      var section = typeof wrapper.closest === 'function' ? wrapper.closest('[id^="shopify-section-"]') : null;
      record = { wrapper:wrapper, diagram:diagram, id:(wrapper.id || (section && section.id) || 'profile')+'-'+(++nextId) };
      instances.set(wrapper,record); active.push(record);
      if (host && typeof host.ResizeObserver === 'function') {
        record.observer = new host.ResizeObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.contentRect.width > 0) draw(record,entry.contentRect.width); });
        });
        record.observer.observe(diagram);
      } else if (host) {
        record.resizeHandler = function () { draw(record); };
        host.addEventListener('resize',record.resizeHandler);
      }
      record.toggleHandler = function () { if (wrapper.open !== false) draw(record); };
      wrapper.addEventListener('toggle',record.toggleHandler);
    }
    record.mesh=mesh; record.copy=wrapperCopy(wrapper); record.copyKey=JSON.stringify(record.copy);
    var copy = record.copy, total = mesh.gaps.reduce(function (sum,gap) { return sum+gap; },0);
    setText(wrapper,'[data-mesh-code]',mesh.code);
    setText(wrapper,'[data-mesh-type]',mesh.fixed ? copy.fixed : mesh.apron ? copy.apron : copy.hinge);
    setText(wrapper,'[data-mesh-profile]',mesh.apron ? copy.apronProfile : copy.frontProfile);
    setText(wrapper,'[data-mesh-source]',mesh.source==='chart' ? copy.sourceChart : mesh.source==='ops' ? copy.sourceOps : copy.sourceFixed);
    setText(wrapper,'[data-mesh-note]',mesh.fixed ? format(copy.fixedTotal,{ total:total.toLocaleString('en-AU'), height:mesh.height*10 }) : mesh.note ? format(copy.chartTotal,{ total:total, height:mesh.height }) : copy.approximate);
    setText(wrapper,'[data-mesh-specs]',measuredLabel(copy.wireCount,'count',mesh.wires,String(mesh.wires))+' · '+mesh.height+' cm '+(mesh.apron ? copy.nominalWidth : copy.nominalHeight)+' · '+measuredLabel(copy.staySpacing,'spacing',mesh.stay,mesh.stay+' mm'));
    draw(record);
    return true;
  }
  if (host && host.document) {
    host.document.addEventListener('shopify:section:unload',function (event) {
      active.slice().forEach(function (record) { if (event.target && event.target.contains(record.wrapper)) destroy(record.wrapper); });
    });
    host.addEventListener('pagehide',function (event) {
      if (!event.persisted) active.slice().forEach(function (record) { destroy(record.wrapper); });
    });
    host.addEventListener('pageshow',function (event) {
      if (event.persisted) active.slice().forEach(function (record) { draw(record); });
    });
    if (host.matchMedia) {
      var colorQuery = host.matchMedia('(prefers-color-scheme: dark)');
      var colorChanged = function () { active.slice().forEach(function (record) { draw(record); }); };
      if (colorQuery.addEventListener) colorQuery.addEventListener('change',colorChanged);
      else if (colorQuery.addListener) colorQuery.addListener(colorChanged);
    }
  }
  return { render:render, destroy:destroy, getProfile:getProfile, buildSvg:buildSvg, familyOf:familyOf,
    qualifiedName:function (name) { var profile = findProfile(name); return profile ? qualifiedName(profile) : ''; } };
});
